export default __webpack_public_path__ + "static/media/01_BlackOnBlack.c742bb49.png";